import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

export const RouteGetMerchflowStorePog_storePogId_ = "/merchflow/store/pog/:storePogId";

export interface QueryParamsGetMerchflowStorePog_storePogId_ {
  includeRanging?: boolean;
}

export interface ResponseGetMerchflowStorePog_storePogId_ {
  id: number;
  pog: PogNonCircular | null;
  status: "DONE" | "ERROR" | "POGGER_IN_PROGRESS" | "UPDATE_IN_PROGRESS" | "NOT_STARTED";
  is_approved: boolean;
  base_pog_id: number;
  store: string;
  store_id?: number;
  template_id: string;
  store_template_id: string | null;
  filter_config_id: number;
  /** Null for POGs that predate store propagation — imports, duplicates, simulations. */
  store_pog_trigger_id: number | null;
  /** As on the Flow Update's `storePogIds` entry that made this pog; absent otherwise. */
  brandsMayCrossAisleBreak?: true;
}

export const RoutePutMerchflowStorePog_storePogId_ = RouteGetMerchflowStorePog_storePogId_;

export interface PayloadPutMerchflowStorePog_storePogId_ {
  pog: PogNonCircular;
  save_as_new?: boolean;
}

export interface ResponsePutMerchflowStorePog_storePogId_ {
  store_pog_id: number;
}
